module.exports = __webpack_public_path__ + "static/wererat-d3a0093379adb00fa542aadd2ba9857e.jpg";